import assetsManager from "../assets/assetsmanager/assestsmanager";
import React, { useState } from "react";

const ConfirmDeleteModal = ({ handleModalClose, handleDelete }) => {
  const [isDeleting, setIsDeleting] = useState(false);

  const handleDeleteClick = () => {
    setIsDeleting(true);
    handleDelete();
  };

  return (
    <div
      className={`editPdfModal backdrop-blur-sm flex items-center justify-center h-full absolute inset-0 bg-[grey] z-[1] bg-opacity-50`}
    >
      <div className="modal bg-white rounded-md items-center flex flex-col gap-2 p-6 w-[25rem] relative">
        <img src={assetsManager.alert} alt="alert" />
        <h2 className="text-lg font-bold text-[#0F0F0F]">Alert!</h2>
        <p className="text-[#676767] text-sm font-normal">
          Are you sure you want to delete?
        </p>
        <div className="flex items-center gap-2">
          <button
            className="flex items-center justify-center gap-1.5 h-8 rounded-md border-[#D1D1D1] border-2 bg-[#FFFFFF] text-[#0F0F0F] text-sm font-medium w-[6rem]"
            onClick={handleModalClose}
            disabled={isDeleting}
          >
            No
          </button>
          <button
            className="flex items-center justify-center gap-1.5 h-8 rounded-md bg-[#C7222A] text-white text-sm font-medium w-[6rem]"
            onClick={handleDeleteClick}
            disabled={isDeleting}
          >
            {isDeleting ? "Deleting..." : "Yes"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDeleteModal;
